module.exports = __webpack_public_path__ + "img/Advisory_banner.06143eaf.jpg";